import { createContext, useContext, useEffect } from "react";

export interface TableRoom {
  need: number;
  available: number;
}

export const TableRoomContext = createContext<(room: TableRoom | null) => void>(() => undefined);

export const useReportTableRoom = (room: TableRoom | null) => {
  const report = useContext(TableRoomContext);
  const need = room ? room.need : 0;
  const available = room ? room.available : 0;
  useEffect(() => report(available > 0 ? { need, available } : null), [report, need, available]);
  useEffect(() => () => report(null), [report]);
};
